import style from "./style.scss";
import Link from "../link";
import namedRoutes from "../../settings/routes";
import { mergeClasses } from "../helpers";

const Footer = () => (
  <footer class={mergeClasses([style.footer, "dark"])}>
    <div class={style.wrapper}>
      <ul class={style.iconLinks}>
        {/* <li>
          <Link
            class={style.icon}
            external
            href={namedRoutes.links.youtube}
            aria-label="YouTube"
          >
            <img src="/icons/brands/youtube.svg" alt="YouTube" />
          </Link>
        </li> */}
        <li>
          <Link
            class={style.icon}
            external
            href={namedRoutes.links.facebook}
            aria-label="Facebook"
          >
            <img src="/icons/brands/facebook.svg" alt="Facebook" />
          </Link>
        </li>
        <li>
          <Link
            class={style.icon}
            external
            href={namedRoutes.links.instagram}
            aria-label="Instagram"
          >
            <img src="/icons/brands/instagram.svg" alt="Instagram" />
          </Link>
        </li>
        <li>
          <Link
            class={style.icon}
            external
            href={namedRoutes.links.contact}
            aria-label="Contact Form"
          >
            <img src="/icons/brands/email.svg" alt="Contact Form" />
          </Link>
        </li>
      </ul>
      <ul class={style.links}>
        <li>
          <Link href={namedRoutes.privacy}>Privacy</Link>
        </li>
        <li>
          <Link href={namedRoutes.terms}>Terms</Link>
        </li>
      </ul>
      <span class={style.copyright}>
        © {new Date().getFullYear()}{" "}
        <span class={style.copyrightHide}>Tyson's Gear Lab by&nbsp;</span>
        <span>Tyson Matanich</span>
      </span>
    </div>
  </footer>
);

export default Footer;
